import { ReactNode } from 'react';

type LayoutProps = {
  children: ReactNode;
};

export function LayoutOnboarding({ children }: LayoutProps) {
  const paths = location.pathname.split('/').filter(Boolean);

  // Create paths mapping for readable names
  const pathMapping: Record<string, string> = {
    signup: 'Create an account',
    'register-device': 'Scan QR code with the Den mobile app',
  };

  // Case: If we're at the root, don't show anything (it will redirect to transactions)
  if (paths.length === 0 || !paths[0]) {
    return null;
  }

  return (
    <div className="flex h-screen w-full overflow-hidden">
      <div className="flex-1 min-w-0 overflow-hidden flex flex-col">
        <header className="h-14 border-b px-6 flex items-center justify-center text-lg">
          {pathMapping[paths[0]]}
        </header>
        <main className="flex-1 overflow-auto bg-muted">
          <div className="w-full h-full">{children}</div>
        </main>
      </div>
    </div>
  );
}
